import React from 'react'

import MenuItem from '~components/shared/menu/menu-item'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5'

export default function ShowAllLocationsCheckbox({
    showMessagesForAllLocations,
    setShowMessagesForAllLocations,
}: {
    showMessagesForAllLocations: boolean
    setShowMessagesForAllLocations: (show: boolean) => void
}) {
    return (
        <MenuItem
            icon={showMessagesForAllLocations ? IoCheckbox : IoSquareOutline}
            onClick={() => {
                setShowMessagesForAllLocations(!showMessagesForAllLocations)
            }}
            iconProps={{
                color: showMessagesForAllLocations ? 'brand.500' : 'gray.400',
            }}
        >
            Show Messages for All Locations?
        </MenuItem>
    )
}
